import * as Const from '../constants/actionConstants';

import State from '../interfaces/states/ExistSubscriptionState';

const initState: State = {
  existSubscription: [],
  isLoading: false,
  message: null,
  editSub: {
    id: null,
    datetime_finish: '',
  },
  dialogWidth: document.body.clientWidth,
};

export default function existSubscription (state: State = initState, action): State {
  switch (action.type) {
    case Const.EXIST_SUB_MESSAGE:
      return {
        ...state,
        message: action.message,
      };

    case Const.EXIST_SUB_IS_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case Const.EXIST_SUB_NOT_LOADING:
      return {
        ...state,
        isLoading: false,
      };

    case Const.EXIST_SUB_SUBSCRIPTIONS:
      return {
        ...state,
        isLoading: false,
        existSubscription: action.existSubscription,
      };

    case Const.EDIT_EXIST_SUB_CHANGE_DATETIME_FINISH:
      return {
        ...state,
        editSub: {
          ...state.editSub,
          datetime_finish: action.datetime_finish,
        },
      };

    case Const.EDIT_EXIST_SUB_ID:
      return {
        ...state,
        editSub: {
          ...state.editSub,
          id: action.id,
        },
      };

    case Const.EDIT_EXIST_SUB_WIDTH:
      return {
        ...state,
        dialogWidth: action.width,
      };

    default:
      return state;
  }
}
